import CityLandingPage from './page';

const santosData = {
  cityName: 'Santos',
  state: 'SP',
  slug: 'palestra-silenciosa-santos',
  coordinates: { lat: -23.9608, lng: -46.3339 },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa santos',
    'silent conference santos sp',
    'aluguel fones sem fio baixada santista',
    'eventos corporativos santos',
    'tradução simultânea santos',
    'festa silenciosa baixada santista',
  ],
  heroTitle: 'palestra silenciosa santos',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências e workshops em Santos. Principal cidade portuária do Brasil com suporte técnico especializado na Baixada Santista.',
  localStats: { clients: '55+', satisfaction: '98%' },
  localTestimonials: [],
  localFAQs: [
    { question: 'Vocês atendem toda a Baixada Santista?', answer: 'Sim! Atendemos Santos, São Vicente, Guarujá, Praia Grande, Cubatão, Bertioga e todo o litoral paulista. Nossa equipe cobre toda a Baixada Santista com rapidez e eficiência.' },
    { question: 'Qual o prazo para contratar em Santos?', answer: 'Recomendamos 2 semanas para eventos em Santos. Para conferências de grande porte no setor portuário e de shipping, sugerimos 1 mês. Na alta temporada de cruzeiros, consulte disponibilidade com antecedência.' },
    { question: 'Os fones funcionam bem em ambientes com ruído, como áreas próximas ao porto?', answer: 'Sim, essa é uma das grandes vantagens! Nossos fones têm excelente isolamento acústico passivo, perfeitos para ambientes com ruído externo como áreas portuárias. O áudio chega cristalino mesmo em condições desafiadoras.' },
    { question: 'Quantos fones sem fio vocês têm para eventos em Santos?', answer: 'Atendemos de pequenos treinamentos (25 fones) a grandes conferências (300+ fones) na Baixada Santista. Equipamentos de última geração com bateria de longa duração para eventos de dia inteiro.' },
    { question: 'Vocês atendem eventos em terminais de cruzeiros e hotéis em Santos?', answer: 'Com certeza! Temos experiência em eventos nos principais hotéis de Santos, no Centro de Convenções e até mesmo em áreas próximas ao terminal de cruzeiros. Nosso sistema é robusto e confiável em qualquer cenário.' },
  ],
  seoTitle: 'Santos Palestra Silenciosa | Aluguel Fones Sem Fio SP | STIB',
  seoDescription: 'Palestra silenciosa Santos: aluguel de fones sem fio para eventos corporativos e treinamentos na Baixada Santista. Ideal para ambientes portuários com isolamento acústico premium. Solicite orçamento!',
  relatedCities: [
    { name: 'São Paulo (Capital)', slug: '/sao-paulo', region: 'Capital' },
    { name: 'Campinas', slug: '/campinas', region: 'Região Metropolitana' },
    { name: 'Barueri / Alphaville', slug: '/barueri', region: 'Grande SP Oeste' },
    { name: 'São José dos Campos', slug: '/sao-jose-dos-campos', region: 'Vale do Paraíba' },
    { name: 'Ribeirão Preto', slug: '/ribeirao-preto', region: 'Interior Norte' },
    { name: 'Guarulhos', slug: '/guarulhos', region: 'Grande SP Leste' },
    { name: 'São Bernardo do Campo', slug: '/sao-bernardo-do-campo', region: 'ABCD Paulista' },
    { name: 'Jundiaí', slug: '/jundiai', region: 'Interior Oeste' },
  ],
};

export default function SantosLandingPage() {
  return <CityLandingPage cityData={santosData} />;
}